module.exports = __webpack_public_path__ + "static/media/note3.15d458de.png";